/**
 * @generated SignedSource<<b5f3743ca2b41f28005a4f1fccae8144>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventAttendeeStatus = "ATTENDING_IN_PERSON" | "ATTENDING_VIRTUAL" | "NOT_ATTENDING" | "PENDING_APPROVAL" | "REJECTED" | "WAITING_IN_PERSON" | "WAITING_VIRTUAL" | "%future added value";
export type StripePaymentIntentStatuses = "CANCELED" | "PROCESSING" | "REQUIRES_ACTION" | "REQUIRES_CAPTURE" | "REQUIRES_CONFIRMATION" | "REQUIRES_PAYMENT_METHOD" | "SUCCEEDED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventAttendButtonButton_event$data = {
  readonly endAt: string;
  readonly eventTicketingTiers: {
    readonly totalCount: number;
  };
  readonly id: string;
  readonly myAttendance: {
    readonly paymentStatus: StripePaymentIntentStatuses | null | undefined;
    readonly visibleStatus: EventAttendeeStatus;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "EventAttendButtonButton_event";
};
export type EventAttendButtonButton_event$key = {
  readonly " $data"?: EventAttendButtonButton_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendButtonButton_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventAttendButtonButton_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendee",
      "kind": "LinkedField",
      "name": "myAttendance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "visibleStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SORT_ORDER_ASC",
            "CREATED_AT_ASC"
          ]
        }
      ],
      "concreteType": "EventTicketingTiersConnection",
      "kind": "LinkedField",
      "name": "eventTicketingTiers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "71758d9b020dae8fd4cd7ce4ec1d55df";

export default node;
